import { isFloatMatch } from '@impuls-coach/util-is';
import { ValidationError } from 'components/hoc/withValidation';
import i18n from 'helper/i18n';
import { VALIDATE_IS_NOT_ALLOWED } from 'helper/validator';

export default function bodyFatValidatorFactory(inputValue: string): Promise<ValidationError | undefined> {
	return new Promise((resolve: Function, reject: Function) => {
		const toVerify: string = inputValue.toString();

		if (toVerify === '') {
			return resolve();
		}

		if (!isFloatMatch(toVerify)) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.cardDetail.tracking.validationBodyFat.invalidFormat'),
			});
			return;
		}

		const value = parseFloat(inputValue);

		if (value <= 0) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.cardDetail.tracking.validationBodyFat.tooLow'),
			});
			return;
		}

		resolve();
	});
}
